import type { CoreAddress, CoreUserAddressResponseSingle } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Create address for user logged.
 *
 * @endpoint POST /api/me/addresses
 * @scope shared
 * @see https://flecto.dev/api-4724190
 */
export async function createUserAddress(
  address: Partial<CoreAddress>
): Promise<CoreUserAddressResponseSingle> {
  const response = await api.post<CoreUserAddressResponseSingle>(
    '/api/me/addresses',
    address
  )

  return response.data
}
